import { render, staticRenderFns } from "./BankFilePage.vue?vue&type=template&id=1559a634&"
import script from "./BankFilePage.vue?vue&type=script&lang=js&"
export * from "./BankFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports